import { baloonMinDesktopHeight, baloonMinMobileHeight } from './constants';

export const defaultSettings = {
  mapState: {
    zoom: 9,
    controls: ['zoomControl', 'geolocationControl'],
    center: [55.75, 37.62],
  },
  mapOptions: {
    searchControlProvider: 'yandex#search',
    suppressMapOpenBlock: true,
    yandexMapDisablePoiInteractivity: true,
    balloonMinHeight: baloonMinDesktopHeight,
    balloonMinWidth: 280,
  },
  placemarkOptions: {
    iconLayout: 'default#imageWithContent',
    iconImageHref: '',
    iconImageSize: [38, 52],
    iconImageOffset: [-18, -24],
    iconContentOffset: [0, 0],
    hideIconOnBalloonOpen: false,
  },
  clustererOptions: {
    clusterNumbers: [10],
    gridSize: 64,
    zoomMargin: 64,
    hasBalloon: false,
    clusterIconShape: {
      type: 'Circle',
      coordinates: [19, 19],
      radius: 19,
    },
  },
  mobileOptions: {
    balloonMinHeight: baloonMinMobileHeight,
  },
};
